import PropTypes from 'prop-types';
import React from 'react';
import {
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifCheckbox,
  MotifLabel,
} from '@ey-xd/motif-react';

const ClosePeriodModal = ({
  showClosePeriodModal,
  handleClosePeriodClick,
  handleCancel,
  period,
  toggleIsAcknowledged,
  isAcknowledged,
  pendingTasks,
  isEngAdminOrSysAdmin,
}) => {
  let closeQuestion = `Close ${period.reportPeriodDescription} for testing?`;
  let closeStatement = 'Reporting and file services will remain accessible.';

  switch (period.reportPeriodStatusDescription) {
    case 'Closed to Testing':
      closeQuestion = `Close ${period.reportPeriodDescription} for reporting?`;
      closeStatement =
        'Reporting and checklist functionality will be closed. File management will remain accessible.';
      break;
    case 'Closed to Reporting':
      closeQuestion = `Complete ${period.reportPeriodDescription}?`;
      closeStatement =
        'Final report will be accessible. Only file downloads will be allowed.';
      break;
  }

  const onYesClick = () => {
    handleClosePeriodClick(
      period.reportPeriodID,
      period.reportPeriodStatusDescription
    );
  };

  return (
    <div>
      {(pendingTasks === 0 && (
        <MotifModal
          show={showClosePeriodModal}
          onClose={handleCancel}
          variant="alt"
        >
          <MotifModalHeader data-testid="mdhdrClosePeriod">
            Close Period
          </MotifModalHeader>
          <MotifModalBody className="pb-0">
            <span className="motif-h5">{closeQuestion}</span>
            <blockquote className="mb-0 mt-3">
              <span>{closeStatement}</span>
              <br />
              {(!isEngAdminOrSysAdmin && (
                <div>
                  <h6>
                    Reversable only by Engagement or System Administrator.
                    <span className="checkbox-wrapper">
                      <MotifCheckbox
                        data-testid="chkbxAcknowledge"
                        type="checkbox"
                        name="ackcheckbox"
                        id="acknowledgeCheckbox"
                        checked={isAcknowledged}
                        onChange={toggleIsAcknowledged}
                      >
                        <MotifLabel>OK</MotifLabel>
                      </MotifCheckbox>
                    </span>
                  </h6>
                </div>
              )) ||
                null}
            </blockquote>
          </MotifModalBody>
          <MotifModalFooter>
            <MotifButton
              variant="secondary"
              className="right"
              type="button"
              onClick={handleCancel}
              data-testid="btnCancel"
            >
              Cancel
            </MotifButton>
            <MotifButton
              variant="primary"
              className="right"
              type="button"
              id="closeButton"
              data-testid="btnYes"
              onClick={onYesClick}
              data-key={period.reportPeriodID}
              disabled={!isAcknowledged && !isEngAdminOrSysAdmin}
            >
              Yes
            </MotifButton>
          </MotifModalFooter>
        </MotifModal>
      )) ||
        null}
    </div>
  );
};

ClosePeriodModal.propTypes = {
  handleClosePeriod: PropTypes.func,
  showClosePeriodModal: PropTypes.bool,
  handleClosePeriodClick: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  period: PropTypes.object.isRequired,
  toggleIsAcknowledged: PropTypes.func.isRequired,
  isAcknowledged: PropTypes.bool,
  pendingTasks: PropTypes.number,
  isEngAdminOrSysAdmin: PropTypes.bool,
};

export default ClosePeriodModal;
